import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { MantenedorConvenioColaboracionService } from 'src/app/services/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.service';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';


export interface DialogData {
    id: any
    rut: any
    dv: any
    nombre: any
    razonSocial: any
    fechaFin: any
    fechaInicio: any
    descripcion: any
    region: any
    idRegion: any
    idComuna: any
    regiones: any
    comunas: any
    categorias: any
    idCuotas: any
    minCuotas: any
    idCategoria: any
    codigoFin: any,
    rol: any,
    url:any,
    visibleConvenio: any
}
declare const Rut: any;
@Component({
    selector: 'edita-convenio-colaboracion',
    templateUrl: '../../pages/mantenedor-convenio-colaboracion/edita-convenio-colaboracion.component.html',
    styleUrls: ['../../pages/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.component.css']
})
export class DialogEditaConvenioColaboracion implements OnInit {
    visibles: any = [{ nombre: 'SÍ', id: true }, { nombre: 'NO', id: false }]
 
    convenioColaboracion: any = {
        id: this.data.id,
        rut: this.data.rut +"-" +this.data.dv,
        //dv: this.data.dv,
        nombre: this.data.nombre,
        razonSocial: this.data.razonSocial,
        idRegion: this.data.idRegion,
        regiones: this.data.regiones,
        fechaFin:this.data.fechaFin,
        fechaInicio:this.data.fechaInicio,
        descripcion: this.data.descripcion,
        url: this.data.url,
        visibleConvenio: this.data.visibleConvenio
    }

    constructor(public dialogRef: MatDialogRef<DialogEditaConvenioColaboracion>,
        private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private mantenedorConvenioColaboracionService: MantenedorConvenioColaboracionService) { }

    ngOnInit(): void {
        let vm = this

        this.mantenedorConvenioColaboracionService.traeRegiones().then
            (regiones => { regiones = regiones })
      
        this.mantenedorConvenioColaboracionService.traeCategoriaConvenio().then(response => this.data.categorias = response
        ).catch(error => console.log(error))
    
    }

    onCancelarClick(): void { this.dialogRef.close() }

    onGuardarEdicionClick(form: NgForm) {
        let vm = this;
        if(!this.convenioColaboracion.rut){
         this.openAlertDialog('Antes de crear el convenio debe escribir el rut.', 'btn-danger')
         return false
        }
        if(!this.convenioColaboracion.nombre){
         this.openAlertDialog('Antes de crear el convenio debe escribir un nombre.', 'btn-danger')
         return false
        }
        if(!this.convenioColaboracion.fechaInicio){
         this.openAlertDialog('Antes de crear el convenio debe seleccionar una fecha Inicio.', 'btn-danger')
         return false
        }
        if(!this.convenioColaboracion.fechaFin){
         this.openAlertDialog('Antes de crear el convenio debe seleccionar una fecha fin.', 'btn-danger')
         return false
        }
       
        if(!this.convenioColaboracion.idRegion  || this.convenioColaboracion.idRegion ==0){
         this.openAlertDialog('Antes de crear el convenio debe escribir una región.', 'btn-danger')
         return false
        }
 
        if(!this.convenioColaboracion.descripcion){
         this.openAlertDialog('Antes de crear el convenio debe agregar una descripción.', 'btn-danger')
         return false
        }
       
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de guardar la edición del convenio?', buttonText: { ok: 'Si', cancel: 'No' } }
            })
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    icon: 'info',
                    text: 'Cargando...'
                });
                Swal.showLoading();

                let fechaInicioC = this.convenioColaboracion.fechaInicio.split('-')[2] + '-' + 
                this.convenioColaboracion.fechaInicio.split('-')[1] + '-' + 
                this.convenioColaboracion.fechaInicio.split('-')[0]
              
                 let fechaFinC = this.convenioColaboracion.fechaFin.split('-')[2] + '-' + 
                 this.convenioColaboracion.fechaFin.split('-')[1] + '-' + 
                 this.convenioColaboracion.fechaFin.split('-')[0]
                 console.log("fechaInicioC1:",fechaInicioC)

                this.mantenedorConvenioColaboracionService.editarConvenioColaboracion( this.convenioColaboracion,fechaInicioC,fechaFinC).
                    then(
                        () => {

                            this.openAlertDialog('Se editó exitosamente el Convenio.', 'btn-success');
                            form.reset();
                            Swal.close();
                            this.dialogRef.close();
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        Swal.close();
                        this.openAlertDialog('Ha ocurrido un error al editar un Convenio.', 'btn-danger')
                    })
            }
        })
    }
 
    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    csvInputChange(fileInputEvent: any) {

        this.convenioColaboracion.archivo = fileInputEvent.target.files[0]
    }


    onDescargarArchivosClick(url: any)
    {
        let vm = this
     
     
        var fileURL=`${environment.urlBlob}/${url}`    
        window.open(fileURL,'_blank')                     
        
    }
    
}